import { render } from "./AvatarGroupToDo.vue?vue&type=template&id=6747b64c&ts=true"
import script from "./AvatarGroupToDo.vue?vue&type=script&lang=ts"
export * from "./AvatarGroupToDo.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__